import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/loading-spinner/LoadingSpinner';

export default function AuthRoute({ children}) {
  const { user, loading } = useAuth();

     if (loading) {
        return (
          <div className="p-4 flex items-center justify-center min-h-[40vh]">
            <LoadingSpinner />
          </div>
        );
      }
    
  if (user) {
    return <Navigate to="/" replace />;
  }

  return children;
}
